import * as React from 'react';
import { ContractCostView } from "./contract-cost.view";

interface ContractCostControllerProps extends ComponentViewProps<ContractItem> {
    mode: ControlMode;
    onModeChanged: (mode: ControlMode) => void;
    type: 'cost' | 'price';
    currencies: CurrencySummary[];
    supplier: SupplierSummary;
    generatePrices?: (priceCurrency: CurrencySummary) => void;
    onMarketChange?: (market: number) => void;
	selectedMarket?: number;
	productType: number;
}

export class ContractCostController extends React.Component<ContractCostControllerProps, any> {
    public constructor(props) {
        super(props);
    }

    render() {
        const model = this.props.model;

		return model && this.props.currencies && <ContractCostView
			productType={this.props.productType}
            mode={this.props.mode}
            model={model}
            setBusy={this.props.setBusy}
            type={this.props.type}
            onModeChanged={this.props.onModeChanged}
            currencies={this.props.currencies}
            supplier={this.props.supplier}
            generatePrices={this.props.generatePrices}
            selectedMarket={this.props.selectedMarket}
            onMarketChange={this.props.onMarketChange}
        />
    }
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-cost.controller.tsx